import React, { FC, useState } from "react";
import { FileUploadOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { enqueueSnackbar } from "notistack";

import {
  StyledListItemIcon,
  StyledListItemText,
  StyledMenuItem,
} from "../../ActionsDropdown.styled";

import { ConfirmationModal } from "@components/common";
import { usePsasImportToForm } from "@api";
import { useUserStore } from "@store/user";
import { useMultistepFormStore } from "@components/common/MultistepForm/MultistepForm.store";

interface PSASImport {}

const PSASImport: FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();
  const { user } = useUserStore();
  const {
    formSettings: {
      formBasics: { id },
    },
  } = useMultistepFormStore();
  const { psasImportToFormAsync, isPendingPsasImportToForm } = usePsasImportToForm(
    user,
    id,
  );

  const handleOpenModal = (): void => {
    setModalOpen(true);
  };

  const handleCloseModal = (): void => {
    setModalOpen(false);
  };

  const confirmImport = async (): Promise<void> => {
    try {
      await psasImportToFormAsync({
        formId: id,
      });
      setModalOpen(false);
    } catch {
      enqueueSnackbar(t("common.somethingWrong"), { variant: "error" });
    }
  };

  return (
    <>
      <StyledMenuItem onClick={handleOpenModal}>
        <StyledListItemIcon>
          <FileUploadOutlined fontSize="medium" />
        </StyledListItemIcon>
        <StyledListItemText>{t("forms.importPSAS")}</StyledListItemText>
      </StyledMenuItem>
      <ConfirmationModal
        open={modalOpen}
        onClose={handleCloseModal}
        onConfirm={confirmImport}
        title={
          <>
            <FileUploadOutlined fontSize="large" />
            <br />
            {t("forms.importPSASTitle")}
          </>
        }
        isLoading={isPendingPsasImportToForm}
        noCancel={isPendingPsasImportToForm}
        description={t("forms.importPSASDescription")}
        confirmText={t("forms.importPSAS")}
      />
    </>
  );
};

export default PSASImport;
